// What the TLD pricing actions say when the API refuses (add, cost, registry, move, offer:
// hoisted on real reuse, like decision-error.ts).
import { ApiError } from "@/lib/api-client";
import { m } from "@/lib/paraglide/messages.js";

const MESSAGES: Partial<Record<string, () => string>> = {
  tld_exists: m.tld_pricing_exists,
  forbidden: m.tld_pricing_forbidden,
};

/** The message for a failed pricing change; null when there is no error. */
export function pricingError(error: unknown): string | null {
  if (!error) return null;
  const code = error instanceof ApiError ? error.code : "internal";
  return (MESSAGES[code] ?? m.tld_pricing_failed)();
}
